import { createSlice } from "@reduxjs/toolkit";
// import auditList from "../../../rtk-apis/audit/auditList";
import studyData from "@custom/rtk-apis/DCM4CHEE/studyData";

const initialState = {
  status:"",
  result:{},
  msg:"",
  loading:false,
  error:""

};

const studyDataSlice = createSlice({
  name: "studyDataSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    console.log("----------",builder)
    builder
      .addCase(studyData.pending, (state, action) => {
        console.log("Pending")
        state.loading = true;
      })
      .addCase(studyData.fulfilled, (state, { payload }) => {
        console.log("Fulfilled",payload)
        state.loading = false;
        state.status = '201';
        state.result = payload;
        state.msg = 'Fetched from PACS';
      })
      .addCase(studyData.rejected, (state, { payload }) => {
        console.log("Rejected")
        state.result = payload;
        state.loading = false;
        state.error = 'Something went wrong!'
      });
  },
});

export default studyDataSlice.reducer;
